function scrollTop() {
 let buttonScroll = document.querySelector('.scroll-to-top');
 if (buttonScroll) {
  buttonScroll.addEventListener('click', (e) => {
   e.preventDefault();
   window.scrollTo({
    top: 0,
    behavior: "smooth"
   });
  })

  window.addEventListener('scroll', function () {
   let offsetScroll = this.scrollY;
   if (offsetScroll > 500) {
    buttonScroll.classList.add('show')
   } else {
    buttonScroll.classList.remove('show')
   }
  })
 }
}
scrollTop()